import { memo } from "react";

import { useDisplayModes } from "../businessLogic/modules/userAccessibilityPreferences/useDisplayModes";

/**
 * DBBL-owned side effect that applies user accessibility DOM attributes
 * (e.g. `data-prefers-contrast` on <html>) on every mount of the
 * LibraryProvider. Consumers do not need to wire this up.
 *
 * On platforms without `document` (React Native), the underlying effect
 * is a no-op.
 */
const DisplayModesEffects = () => {
  useDisplayModes();
  return null;
};

export default memo(DisplayModesEffects);
